export class SortEvent {
    sort: string;
    order: string;

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}
